module.exports = __webpack_public_path__ + "static/media/CDfrontcoversmflat.12a6da31.webp";